import moment from 'moment';
import React, { Dispatch, SetStateAction, useEffect } from 'react';
import { dateFormat, format12Hour, singleDigit12HourFormat, tempTimeOptions } from '../../../constants/constants';
import styles from './SelectedUnitAvailability.module.css';

interface Data {
    name: string;
    nickName: string;
}

interface SelectedUnitAvailabilityProps {
    data: Data;
    officeHoursOfWeekDay: {
        label: string;
        value: string;
    }[];
    isOfficeHoursChecked: boolean;
    selectedDate: Date;
    setSelectedSlots: Dispatch<SetStateAction<number[]>>;
    setSlotRange: Dispatch<SetStateAction<string>>;
    selectedSlots: number[];
    selectedWeekDay: string;
}

const SelectedUnitAvailability = ({
    officeHoursOfWeekDay,
    data,
    isOfficeHoursChecked,
    selectedDate,
    selectedSlots,
    setSelectedSlots,
    setSlotRange,
    selectedWeekDay,
}: SelectedUnitAvailabilityProps) => {
    // const selectSlotHandler = (index: number) => {
    //     const timeFormat = 'HH:mm';
    //     const data = tempTimeOptions;

    //     if (selectedSlots.length === 0) {
    //         setSelectedSlots([index]);
    //     } else {
    //         const lastSelectedSlot = selectedSlots[selectedSlots.length - 1];

    //         if (
    //             index === lastSelectedSlot + 1 &&
    //             data[index].value === moment(`${data[lastSelectedSlot].value}`, timeFormat).add(1, 'hours').format(timeFormat)
    //         ) {
    //             setSelectedSlots([...selectedSlots, index]);
    //         } else if (
    //             index === selectedSlots[0] - 1 &&
    //             data[selectedSlots[0]].value === moment(`${data[index].value}`, timeFormat).add(1, 'hours').format(timeFormat)
    //         ) {
    //             setSelectedSlots([index, ...selectedSlots]);
    //         } else {
    //             setSelectedSlots([index]);
    //         }
    //     }
    // };

    const selectSlotHandler = (index: number) => {
        if (selectedSlots.includes(index)) {
            setSelectedSlots(selectedSlots.filter((slot) => slot !== index));
        } else {
            setSelectedSlots([...selectedSlots, index].sort((a, b) => a - b));
        }
    };

    // useEffect(() => {
    //     let slotRange = '';
    //     const data = tempTimeOptions;

    //     const firstSlot = data[selectedSlots[0]];
    //     const lastSlot = data[selectedSlots[selectedSlots.length - 1]];

    //     if (firstSlot && lastSlot) {
    //         const startTime = moment(firstSlot.value, format12Hour).format(singleDigit12HourFormat);
    //         const endTime = moment(lastSlot.value, format12Hour).add(1, 'hours').format(singleDigit12HourFormat);

    //         slotRange = `${startTime} - ${endTime}`;
    //     }

    //     setSlotRange(slotRange);
    // }, [selectedSlots]);

    useEffect(() => {
        const data = tempTimeOptions;

        const sortedSlots = [...selectedSlots].sort((a, b) => a - b);
        const ranges: { startTime: string; endTime: string }[] = [];

        let tempGroup: number[] = [];

        for (let i = 0; i < sortedSlots.length; i++) {
            if (tempGroup.length === 0 || sortedSlots[i] === tempGroup[tempGroup.length - 1] + 1) {
                tempGroup.push(sortedSlots[i]);
            } else {
                const start = moment(data[tempGroup[0]].value, format12Hour).format(singleDigit12HourFormat);
                const end = moment(data[tempGroup[tempGroup.length - 1]].value, format12Hour)
                    .add(1, 'hour')
                    .format(singleDigit12HourFormat);
                ranges.push({ startTime: start, endTime: end });
                tempGroup = [sortedSlots[i]];
            }
        }
        if (tempGroup.length) {
            const start = moment(data[tempGroup[0]].value, format12Hour).format(singleDigit12HourFormat);
            const end = moment(data[tempGroup[tempGroup.length - 1]].value, format12Hour)
                .add(1, 'hour')
                .format(singleDigit12HourFormat);
            ranges.push({ startTime: start, endTime: end });
        }
        setSlotRange(JSON.stringify(ranges));
    }, [selectedSlots]);

    return (
        <div className={styles.unitName}>
            <p>
                New availability for {data?.name} {data?.nickName ? `"${data?.nickName}"` : ''}
            </p>

            <div className={styles.slotsListing}>
                {isOfficeHoursChecked
                    ? officeHoursOfWeekDay &&
                    !!officeHoursOfWeekDay.length &&
                    officeHoursOfWeekDay.map((officeHours, index) => (
                        <div className={styles.slotItem} key={index}>
                            <span key={index}>{moment(officeHours.label, 'HH:mm').format('h A')} - </span>
                            <span>&nbsp;{moment(officeHours.label, 'HH:mm').add(1, 'hours').format('h A')}</span>
                        </div>
                    ))
                    : tempTimeOptions?.map((hours: { label: string }, index: number) => {
                        const isSelected = selectedSlots.includes(index);

                        const currentHour = moment().format('HH:mm');

                        const startTime = moment(hours.label, 'HH:mm').startOf('hour');
                        const todaysDate = moment().format('YYYY-MM-DD');

                        if (
                            moment(selectedDate).format(dateFormat) === todaysDate &&
                            startTime.add(1, 'hour').isSameOrAfter(moment(currentHour, 'HH:mm'))
                        ) {
                            return (
                                <div
                                    onClick={() => selectSlotHandler(index)}
                                    className={isSelected ? styles.selected : styles.fullDaySlotItem}
                                    key={index}>
                                    <span key={index}>{moment(hours.label, 'HH:mm').format('h A')} - </span>{' '}
                                    <span>&nbsp;{moment(hours.label, 'HH:mm').add(1, 'hours').format('h A')}</span>
                                </div>
                            );
                        } else if (moment(selectedDate).format(dateFormat) !== todaysDate) {
                            return (
                                <div
                                    onClick={() => selectSlotHandler(index)}
                                    className={isSelected ? styles.selected : styles.fullDaySlotItem}
                                    key={index}>
                                    <span key={index}>{moment(hours.label, 'HH:mm').format('h A')}</span> -{' '}
                                    <span>{moment(hours.label, 'HH:mm').add(1, 'hours').format('h A')}</span>
                                </div>
                            );
                        }
                    })}
            </div>

            {isOfficeHoursChecked && officeHoursOfWeekDay && !officeHoursOfWeekDay.length && (
                <div className={styles.closedOfficeText}>
                    <p>You set your office as closed on {selectedWeekDay}</p>
                </div>
            )}
        </div>
    );
};

export default SelectedUnitAvailability;
